import { useEffect, useState } from "react";

export const TRACKING_SCRIPT_DELAY_MS = 4000;

/**
 * Waits for the load event and then for a delay on top of it.
 * @param delayMs How long to wait after the load event, 0 waits for nothing
 * @returns False until the page has loaded and the delay has passed
 */
export function useDelayAfterLoad(delayMs: number) {
    const [elapsed, setElapsed] = useState(delayMs <= 0);

    useEffect(() => {
        if (delayMs <= 0) return;

        let timeout: number | undefined;

        /**
         * Starts the delay that gates the script.
         */
        function startTimer() {
            timeout = window.setTimeout(() => setElapsed(true), delayMs);
        }

        if (document.readyState === "complete") {
            startTimer();
        } else {
            window.addEventListener("load", startTimer);
        }

        return () => {
            window.clearTimeout(timeout);
            window.removeEventListener("load", startTimer);
        };
    }, [delayMs]);

    return elapsed;
}
